const AbiEntrySummaryResponseApiUrls = {
  GET: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/entry-status-response/get`,
};

export default AbiEntrySummaryResponseApiUrls
